/**
 * Format numbers in a compact way
 * Examples:
 * 999 -> 999
 * 1000 -> 1k
 * 1500 -> 1.5k
 * 2340 -> 2.3k
 * 1000000 -> 1M
 * 1500000 -> 1.5M
 */
export function formatNumber(num) {
  if (num === null || num === undefined) return '0'
  
  const absNum = Math.abs(num)
  const sign = num < 0 ? '-' : ''
  
  if (absNum < 1000) {
    return sign + absNum.toString()
  } else if (absNum < 1000000) {
    // Thousands (k)
    const thousands = absNum / 1000
    if (thousands % 1 === 0) {
      return sign + thousands.toFixed(0) + 'k'
    }
    return sign + thousands.toFixed(1) + 'k'
  } else if (absNum < 1000000000) {
    // Millions (M)
    const millions = absNum / 1000000
    if (millions % 1 === 0) {
      return sign + millions.toFixed(0) + 'M'
    }
    return sign + millions.toFixed(1) + 'M'
  } else {
    // Billions (B)
    const billions = absNum / 1000000000
    if (billions % 1 === 0) {
      return sign + billions.toFixed(0) + 'B'
    }
    return sign + billions.toFixed(1) + 'B'
  }
}

/**
 * Format number with full text
 * Examples: 1000 -> "1k", 1500 -> "1.5k"
 */
export function formatRespect(num) {
  return formatNumber(num)
}
